function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 29.988c8.288 0 15-6.444 15-14.4s-6.712-14.4-15-14.4c-8.287 0-15 6.444-15 14.4s6.713 14.4 15 14.4z",
  fill: "#3350BC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.65 16.128h-1.912v-.816h1.875v-1.464h-1.875V9.96H17.8v7.152c0 1.548-.737 2.448-.987 2.46v1.464c1.387 0 2.512-1.764 2.512-3.924v-5.688h.888v5.616c0 2.904-1.7 4.8-4.513 5.088V20.04h-.762c-1.363 0-2.813-.288-2.813-3.756V9.96h-3.8v3.888H6.35v1.464h1.975v.816H6.388v1.464h1.95c.087 4.152 3.462 5.832 4.875 5.832V21.96c-.713 0-3.363-1.128-3.363-4.524v-6.024h.763v4.86c0 3.192 1.175 4.896 3.575 5.184v2.172h.762c3.875 0 6.525-2.4 6.775-6.036h1.925v-1.464z",
  fill: "#fff"
});

function SvgUntb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "81b505f60ee3b08257ca70c250cd5170.svg";
export { SvgUntb as ReactComponent };